
import { List, Card, Space } from "antd";
import React, { useEffect, useState } from "react";
import { priceTypes, pricingCategory } from "../../../enums/pricing.enum";
import { currencyDisplay } from "../../../utils/helpers";
import { useSearchParams } from "react-router-dom";

const B2C2BPriceDetails = (
  props: {
    priceCurrency:string,
    prices: any[],
    paxCount: number;
    roomTypes?: Record<string, string>;
  }
) => {
  const { priceCurrency, prices, roomTypes } = props;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const categories = pricingCategory(roomTypes || type || undefined);
  
  var pricingTypes:any[] = [], priceTable:any = {}, priceList:any[] = [];
  if(prices.length>0){
    pricingTypes = prices.map((price:any) => price.type);
    prices.forEach((price:any) => {
      const pricingObj = {
        ...price,
        label: price.display_price
      };

      priceTable[price.type] = pricingObj;

      priceList.push({
        title: `${price.display_price} ${priceTypes[price.type]}`,
        type: price.type,
        ...pricingObj
      })
    });
  }

  const priceLabel = (price) => price == 0 ? "TBC" : currencyDisplay(priceCurrency, price);

  const selectedPriceTypeByPaxCount = ({start, end}) => props.paxCount >= start && props.paxCount <= end;

  return (
    <div className="price-details-container">
      <div className="price-details-container_content">
        <div className="pricing-table">
          <div className="pricing-table-category">
            <div className="pricing-table-category-header">
              &nbsp;
            </div>
            {
              Object.entries(categories).map(category => <span key={category[0]}> {category[1] as string} </span>)
            }
          </div>
          {
            pricingTypes.map((type:any, index) => (
              <div key={index} className={`pricing-table-column ${selectedPriceTypeByPaxCount(priceTable[type]) && 'selected'}`}>
                <div className="pricing-table-column-header">
                  <div>{priceTable[type].label}</div>
                  <div className="price-type">{priceTypes[type]}</div>
                </div>
                
                {
                  Object.entries(categories).map((category, index) => {
                    const price = priceTable[type][category[0]];
                    return <span key={index} className="pricing-table-price"> {priceLabel(price)} </span>
                  })
                }

              </div>                
            ))
          }
        </div>

        {
          priceList.length > 0 && (
            <List
              id="pricing-list"
              itemLayout="vertical"
              dataSource={priceList}
              renderItem={(item) => (
                <List.Item>
                  <Card className={item.type}>
                    <div className="pricing-header"> {item.title} </div>
                    <div className="pricing-body"> 
                      <Space size={15} direction="vertical" style={{display: 'flex'}}>
                        {
                          Object.entries(categories).map(category => {
                            const price = item[category[0]];
                            return (
                              <div key={category[0]} className="pricing"> 
                                <div className="category"> {category[1] as string} </div>
                                <div className="price">{ priceLabel(price) }</div>
                              </div>
                            )
                          })
                        }
                      </Space>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          )
        }

      </div>
    </div>
  )
}

export default B2C2BPriceDetails;